import ServiceBase from '../../services/ServiceBase';
import priceVolumeProxy from '../../../core/proxies/technical/PriceVolumeProxy';

class PriceVolumeService extends ServiceBase {
  getListPriceVolume(params, source) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache(
          'PriceVolumeService.GetPriceVolumeAnalysis',
          params,
        )(() => priceVolumeProxy.getListPriceVolume(params, source)),
    );
  }
}
const priceVolumeService = new PriceVolumeService();
export default priceVolumeService;
